import { render, staticRenderFns } from "./number-of-customer.vue?vue&type=template&id=15606321&scoped=true"
import script from "./number-of-customer.vue?vue&type=script&lang=js"
export * from "./number-of-customer.vue?vue&type=script&lang=js"
import style0 from "./number-of-customer.vue?vue&type=style&index=0&id=15606321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15606321",
  null
  
)

export default component.exports